<template>
  <div class="page-fixed">
    <h5 class="detail-title">{{ infoData.title }}</h5>
    <div class="detail-subtitle">
      <span class="first-tab" v-if="infoData.source">{{
        infoData.source
      }}</span>
      <span class="sec-tab" v-if="infoData.pubTime">{{
        infoData.pubTime | timeStampToString
      }}</span>
    </div>
    <div class="ql-snow">
      <div
        class="ql-editor"
        v-html="richText"
        @click="addComment($event)"
      ></div>
    </div>
    <!-- <div class="richText" v-html="richText" @click="addComment($event)"></div> -->
    <van-empty
      v-if="noData"
      :image="require('@/assets/img-m/no-list.png')"
      :description="$t('暂无数据')"
    />
    <van-image-preview v-model="show" :images="images"></van-image-preview>
    <!-- <p class="read-num" v-show="richText != ''">
      {{ $t('浏览量') }}：{{ pageviews }}
    </p> -->
  </div>
</template>

<script>
import getTranslation from '@/locale/getTranslation'
import { getNoticeContentDetail, getPv } from '@/api/news'
export default {
  data() {
    return {
      infoData: {},
      richText: '',
      pageviews: 0,
      noData: false,
      id: '',
      images: [],
      show: false
    }
  },
  beforeCreate() {
    try {
      let options = {
        source: '新闻中心-资讯详情',
        isShow: true
      }
      window.bridge.onShowShareButton(JSON.stringify(options))
    } catch (error) {
      console.log('APP调起分享按钮监听失败')
    }
    this.$toast.loading({
      duration: 0,
      message: getTranslation('加载中...'),
      forbidClick: true
    })
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getDetailView()
    // this.getPvNum(this.id)
  },
  methods: {
    async getPvNum(id) {
      let { result } = await getPv(id)
      this.pageviews = result.pv
    },
    async getDetailView() {
      // const _self = this
      const res = await getNoticeContentDetail(this.id)
      if (res.result.data) {
        let content = res.result.data
        this.infoData = content
        let { richText, title } = content
        document.title = title
        //richText富文本内容
        if (richText !== '') {
          this.richText = richText
        } else {
          this.noData = true
        }
      } else {
        this.noData = true
      }
      this.$toast.clear()
    },
    addComment: function(event) {
      switch (event.target.nodeName) {
        case 'A': {
          event.preventDefault()
          this.downloadFile(event.target.href)
          break
        }
        case 'IMG': {
          if (event.target.parentNode.tagName !== 'A') {
            event.preventDefault()
            this.images = [event.target.currentSrc]
            this.show = true
          }
          break
        }
      }
    },
    downloadFile(url) {
      const fileType = url.substring(url.lastIndexOf('.') + 1)
      try {
        let options = {
          source: '新闻中心-活动资讯',
          fileType,
          url
        }
        window.bridge.onFileDownload(JSON.stringify(options))
      } catch (error) {
        console.log('调用APP下载方法失败')
        window.open(url)
      }
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/common.scss';
.read-num {
  color: #bcbcbc;
  font-size: 0.24rem;
  padding: 0 0.3rem 0.3rem 0.3rem;
}
.downloadFile {
  text-align: center;
  span {
    display: inline-block;
    width: 2rem;
    line-height: 0.6rem;
    text-align: center;
    border-radius: 0.12rem;
    font-size: 0.26rem;
    color: #fff;
    @include linearBg();
  }
}
.detail-title {
  font-size: 0.45rem;
  padding: 0.3rem;
  line-height: 130%;
}
.detail-subtitle {
  font-size: 0.24rem;
  line-height: 100%;
  padding: 0 0.3rem;
}
.first-tab {
  margin-right: 0.2rem;
  color: #fe8c01;
}
.sec-tab {
  color: #bcbcbc;
  font-size: 0.24rem;
}
</style>
